import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Badge, Button, Icon } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import TitleInput from './TitleInput';

const CampaignDetailsHeader = memo(
    ({
        badgeType,
        campaignTitle,
        onBack,
        onPreview,
        onSend,
        onTitleChange,
        onTitleSave,
        status,
    }) => (
        <div className="campaign-details__header">
            <div className="campaign-details__header-left">
                <div
                    className="campaign-details__back-button"
                    onClick={onBack}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => e.key === 'Enter' && onBack()}
                >
                    <Icon name="arrowBack" />
                </div>
                <TitleInput title={campaignTitle} onChange={onTitleChange} onSave={onTitleSave} />
                <Badge type={badgeType}>{status}</Badge>
            </div>
            <div className="campaign-details__header-actions">
                <Button type="secondary" size="small" onClick={onPreview} isDisabled>
                    {getLiteral('action_preview')}
                </Button>
                <Button type="primary" size="small" isDisabled onClick={onSend}>
                    {getLiteral('action_send')}
                </Button>
            </div>
        </div>
    ),
);

CampaignDetailsHeader.displayName = 'CampaignDetailsHeader';

CampaignDetailsHeader.propTypes = {
    badgeType: PropTypes.string,
    campaignTitle: PropTypes.string,
    onBack: PropTypes.func.isRequired,
    onPreview: PropTypes.func.isRequired,
    onSend: PropTypes.func.isRequired,
    onTitleChange: PropTypes.func.isRequired,
    onTitleSave: PropTypes.func.isRequired,
    status: PropTypes.string,
};

export default CampaignDetailsHeader;
